import TicketService from "@/services/ticket.service";
import axios from "axios";

export const ticketModule = {
    namespaced: true,
    state: {
        requests: [],
        tickets: new Map(),
        categories: new Map(),
        messages: new Map(),
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async listTicket({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listTicket");
            return TicketService.listTicket(axiosSource).then(
                async data => {
                    commit('updateTicketsList', data);
                    await dispatch('clearRequest', "listTicket");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createTicket({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createTicket");
            return TicketService.createTicket(axiosSource, data).then(
                async data => {
                    commit('insertTicket', data);
                    await dispatch('clearRequest', "createTicket");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async closeTicket({commit, dispatch}, ticketId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "closeTicket");
            return TicketService.closeTicket(axiosSource, ticketId).then(
                async data => {
                    commit('insertTicket', data);
                    await dispatch('clearRequest', "closeTicket");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listCategory({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listCategory");
            return TicketService.listCategory(axiosSource).then(
                async data => {
                    commit('updateCategoriesList', data);
                    await dispatch('clearRequest', "listCategory");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createCategory({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createCategory");
            return TicketService.createCategory(axiosSource, data).then(
                async data => {
                    commit('insertCategory', data);
                    await dispatch('clearRequest', "createCategory");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listMessage({commit, dispatch}, ticketId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listTicketMessage");
            return TicketService.listMessage(axiosSource, ticketId).then(
                async data => {
                    commit('updateMessagesList', data);
                    await dispatch('clearRequest', "listTicketMessage");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async newMessage({commit, dispatch}, {ticketId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "newTicketMessage");
            return TicketService.newMessage(axiosSource, ticketId, data).then(
                async data => {
                    commit('insertMessage', data);
                    await dispatch('clearRequest', "newTicketMessage");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateTicketsList(state, data) {
            state.tickets = new Map()
            for (const entity of data) {
                state.tickets.set(entity.id, entity)
            }
        },
        updateCategoriesList(state, data) {
            state.categories = new Map()
            for (const entity of data) {
                state.categories.set(entity.id, entity)
            }
        },
        updateMessagesList(state, data) {
            state.messages = new Map()
            for (const entity of data) {
                state.messages.set(entity.id, entity)
            }
        },
        insertTicket(state, data) {
            state.tickets.set(data.id, data)
        },
        insertCategory(state, data) {
            state.categories.set(data.id, data)
        },
        insertMessage(state, data) {
            state.messages.set(data.id, data)
        },
    }
};